import { runAxios } from '../../handlers/axios';
import { getUsefulVars } from '../../handlers/helpers';
import { onLink } from '../../handlers';

export const set_ai_opts = (props,qObj,callbackArgs) => {
  const uv = getUsefulVars(props);
  const url = uv.stateProps.domain + '/wp-json/rsworks/v1/generateSummary';
  const dataToSend = JSON.stringify(uv.stateProps.dataToSave.saved.resumes);
  const request = { survey: dataToSend, resumeIndex: uv.resumeIndex };

  const args = {
    props: props,
    message: 'Set AI Options',
    uv:uv,
    qObj:qObj,
    callbackArgs:callbackArgs,
  };
  uv.stateProps.setSpinnerMessage('Brace yourself for a jaw-dropping and stunning reveal!\n' +
    '(Don\'t forget to download the Word doc...)');
  uv.stateProps.setSpinnerImage('preview.gif');
  uv.stateProps.onSpinnerOpen();

  runAxios(url, request, set_ai_opts_callback, args);

};

export const set_ai_opts_callback = (result, args) => {
  const props = args.props;
  const qObj = args.qObj;
  const uv = args.uv;
  uv.resume.regenCS = true;
  qObj.options = result.data;
  uv.stateProps.setSpinnerImage('default.gif');
  uv.stateProps.setSpinnerMessage('');
  uv.stateProps.onSpinnerClose();

  onLink(false, props.formikProps, props.stateProps, 'download', 0, 'section');
};

export const set_ai_opts_for_preview = (props,index = -1) => {
  const stateProps = props.stateProps;
  const formikProps = props.formikProps;
  const resumeIndex = index === -1 ? stateProps.sectionData.resumeIndex : index;
  const url = stateProps.domain + '/wp-json/rsworks/v1/generateSummary';
  const dataToSend = JSON.stringify(stateProps.dataToSave.saved.resumes);
  const request = { survey: dataToSend, resumeIndex: resumeIndex };
  const args = {
    props: props,
    message: 'Set AI Options',
  };
  if (stateProps.sectionData.regenCS && stateProps.dataToSave.saved.resumes[resumeIndex].download === undefined) {

    stateProps.setSpinnerMessage('Brace yourself for a jaw-dropping and stunning reveal!\n' +
      '(Don\'t forget to download the Word doc...)');
    stateProps.setSpinnerImage('preview.gif');
    stateProps.onSpinnerOpen();
    runAxios(url, request, set_ai_opts_for_preview_callback, args);
  } else {
    onLink(false, formikProps, stateProps, 'preview',0,'section', resumeIndex);
  }
};
export const set_ai_opts_for_preview_callback = (result, args) => {
  const uv = getUsefulVars(args.props);
  //delete jobSeekerData[0].CPQ6;
  const ai = result.data;
  uv.resume.download = [];
  if(ai[0] !== undefined && ai[0].value !== undefined) {
    uv.resume.download.push({ D1: ai[0].value });
  } else {
    uv.resume.download.push({ D1: '' });
  }

  uv.stateProps.setaiopts(ai);
  uv.resume.regenCS = false;
  uv.stateProps.setSpinnerImage('default.gif');
  uv.stateProps.setSpinnerMessage('');
  uv.stateProps.onSpinnerClose();

  onLink(false, uv.formikProps, uv.stateProps, 'preview')
  return ai;
};